import React, { useState } from "react";
import SEO from "../components/SEO";
import HeroInner from "../components/HeroInner/HeroInner";
import Services from "../components/Services";
import ChatBot from "../components/ChatBot";
import GlobalScripts from "../components/GlobalScripts";
import Menu from "../components/Menu/Menu";
import Footer from "../components/Footer";
import Tooltip from "../components/Tooltip";
import ContactModal from "../components/ContactModal/ContactModal"; // Modal integrado
import "./DesarrolloWeb.css";

function Marketing() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <SEO
        title="Marketing Digital | SEO, Ads y Estrategias"
        description="Estrategias de marketing digital para generar tráfico y ventas. Posicionamiento SEO y publicidad en Google y Meta Ads."
        url="https://juancarlosmancharamos.ar/marketing-digital"
      />

      <Menu />

      <HeroInner
        title="Marketing Digital"
        subtitle="Estrategias orientadas a resultados para crecer online"
        bg="/assets/images/bg-dev.jpg"
      />

      <section className="container dev-section">
        <div className="dev-inner-wrap">
          
          {/* Encabezado y Texto Principal */}
          <div className="dev-header">
            <div className="dev-intro-content">
              <h2 className="dev-title">Estrategias que Multiplican tus Resultados</h2>
              <p className="dev-lead">
                Diseñamos e implementamos campañas de marketing digital enfocadas 100% en el <strong>Retorno de Inversión (ROI)</strong>. Atrae tráfico cualificado, genera leads y convierte visitas en clientes leales.
              </p>
              <p>
                No se trata solo de tener presencia online, sino de ser visible exactamente para quienes ya están buscando lo que ofreces. Combino el poder del posicionamiento orgánico a largo plazo con campañas publicitarias de alta precisión para escalar la rentabilidad de tu negocio.
              </p>
            </div>
          </div>

          {/* Cuadrícula de Características con Iconos (Enfocados en Marketing) */}
          <div className="dev-features">
            <div className="dev-feature-card">
              <div className="dev-icon">
                {/* Icono de Lupa/Búsqueda (SEO) */}
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><polyline points="11 8 11 11 14 14"></polyline></svg>
              </div>
              <h3>Posicionamiento SEO</h3>
              <p>Domina los motores de búsqueda. Optimización técnica y de contenidos para que tu web aparezca en los primeros resultados de Google de forma orgánica.</p>
            </div>

            <div className="dev-feature-card">
              <div className="dev-icon">
                {/* Icono de Objetivo/Diana (Ads) */}
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg>
              </div>
              <h3>Campañas SEM y Ads</h3>
              <p>Publicidad hiper-segmentada en Google Ads y Meta Ads (Facebook e Instagram) para captar clientes potenciales listos para comprar desde el primer día.</p>
            </div>

            <div className="dev-feature-card">
              <div className="dev-icon">
                {/* Icono de Embudo (Conversión) */}
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>
              </div>
              <h3>Optimización de Conversión</h3>
              <p>CRO (Conversion Rate Optimization) y diseño persuasivo para garantizar que el tráfico que llega a tu sitio no rebote y se transforme en ventas reales.</p>
            </div>

            <div className="dev-feature-card">
              <div className="dev-icon">
                {/* Icono de Gráfico de Barras (Analítica) */}
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>
              </div>
              <h3>Analítica y Datos</h3>
              <p>Decisiones respaldadas por métricas exactas (Google Analytics 4). Monitoreo constante para medir el crecimiento y optimizar tu presupuesto continuamente.</p>
            </div>
          </div>

          {/* Banner de Llamada a la Acción (CTA) */}
          <div className="dev-cta-banner">
            <h3>¿Quieres dejar de perder clientes frente a tu competencia?</h3>
            <p>Diseñemos un plan de marketing a tu medida y comencemos a generar tráfico de valor.</p>
            <button 
              onClick={() => setIsModalOpen(true)} 
              className="dev-btn-primary" 
              style={{border: 'none', cursor: 'pointer', fontFamily: 'inherit'}}
            >
              Consultar Estrategia
            </button>
          </div>
          
        </div>
      </section>

      {/* Sección + servicios */}
      <section id="abt-lnk" className="center-first">
        <div className="gp no-tpgp btm-spc130">
          <div className="container">
            <div className="skls-wrp2 ovrlp-60 text-center">
              <div className="skls-inr">
                <h2 itemProp="headline">
                  + servicios
                </h2>
              </div>
              <Services />
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
      <ChatBot />
      <Tooltip />
      <GlobalScripts />

      {/* Modal Anti-Spam */}
      <ContactModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        defaultService="Marketing Digital" 
      />
    </>
  );
}

export default Marketing;